module.exports = __webpack_public_path__ + "static/blog-splash-4-c1cdee82beacecdd967cc9dae057abcf.jpg";